import { Text, Modal } from '@simplywallst/ui-core';
import { useDeleteNarrativeAnnouncement } from '@/pages/Narrative/hooks/useDeleteNarrativeAnnouncement';

interface Props {
  onClose: () => void;
  slug: string;
  announcementId: string;
}

const DeleteAnnouncementModal = ({ onClose, slug, announcementId }: Props) => {
  const { mutate } = useDeleteNarrativeAnnouncement(slug);
  return (
    <Modal
      title="Delete Announcement"
      onClose={onClose}
      primaryLabel="Delete"
      onPrimaryClick={() => {
        mutate(announcementId);
        onClose();
      }}
      secondaryLabel="Cancel"
      onSecondaryClick={onClose}
      fullscreen
    >
      <Text typography="small" color="black">
        We&apos;re about to remove this announcement permanently. Are you sure?
      </Text>
    </Modal>
  );
};

export default DeleteAnnouncementModal;
